<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isUpdating: false,
      quantity: 1
    };
  },

  computed: {
    ...mapGetters([
      'orderQuantity'
    ]),

    minusButtonDisabled() {
      return this.isUpdating || this.quantity == 1;
    },

    plusButtonDisabled() {
      return this.isUpdating || this.quantity == 99;
    }
  },

  methods: {
    ...mapActions([
      'updateAmounts'
    ]),

    ...mapMutations([
      'setOrderQuantity'
    ]),

    decreaseQuantity() {
      this.updateQuantity(this.quantity - 1);
    },

    increaseQuantity() {
      this.updateQuantity(this.quantity + 1);
    },

    updateQuantityEvent() {
      this.updateQuantity(event.currentTarget.value);
    },

    updateQuantity(value) {
      const oldValue = this.quantity;
      let newValue = parseInt(value);

      if (newValue < 1) {
        newValue = 1;
      }

      if (newValue > 99) {
        newValue = 99;
      }

      this.isUpdating = true;
      this.quantity = newValue;

      this.setOrderQuantity(newValue);

      this.updateAmounts().then(() => {
        this.isUpdating = false;
      }).catch(() => {
        this.isUpdating = false;
        this.quantity = oldValue;
        this.setOrderQuantity(oldValue);
      });
    }
  }
};
</script>

<template>
  <div class="c-quantity-control">
    <button
      class="c-quantity-control__button c-quantity-control__button--minus"
      type="button"
      :disabled="minusButtonDisabled"
      @click="decreaseQuantity"
    >
      -
    </button>

    <input
      ref="quantityInput"
      class="c-quantity-control__input"
      type="number"
      :disabled="isUpdating"
      :name="name"
      :value="quantity"
      @keyup="updateQuantityEvent"
    >

    <button
      class="c-quantity-control__button c-quantity-control__button--plus"
      type="button"
      :disabled="plusButtonDisabled"
      @click="increaseQuantity"
    >
      +
    </button>
  </div>
</template>
